export function useUniqueID() {
  const getID = () => {
    const random = Math.random();
    const alphanumeric = random.toString(36);
    return alphanumeric.slice(2);
  };

  return { getID };
}
